import { createSlice } from '@reduxjs/toolkit';
import db from '../../hooks/useFirebase';
import { v1 as uuid } from 'uuid';
import axios from 'axios';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
};

const slice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // SUCCESS
    endLoading(state) {
      state.isLoading = false;
    },
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export async function checkAndDeleteVideoAdmin(uid) {
	await updateVideoStatusAdmin(0,uid)

	try {
		let initialQuery = await db.firestore().collection('offers').where("user","==",uid).limit(100);
		let documentSnapshots = await initialQuery.get();
		let documentData = documentSnapshots.docs.map(document => document.data());

		documentData.map( async (item) => {
			await deleteVideoAdmin(item.video_name, item.id)
		})

		return true
	} catch (error) {
		console.log(error)
		return false
	}
}
async function deleteVideoAdmin(url, uid) {
	try {
		// Create a reference to the file to delete
		var desertRef = await db.storage().ref().child("videos/"+url);

		// Delete the file
		let result = await desertRef.delete().then(async () => {
			//очистить данные о видео
			await db.firestore().collection('offers').doc(uid).update({
				responses: [],
				video: "",
				video_mobile: "",
				videoApproved: false,
				status: false,
				video_name: "",
				videoDate: "",
			})

			return 1
		}).catch(function(e) {
			console.log(e.code)
			return e
		});

        if(result.code=="storage/object-not-found") {
            //очистить данные о видео
			await db.firestore().collection('offers').doc(uid).update({
				responses: [],
				video: "",
				videoApproved: false,
				status: false,
				video_name: "",
				videoDate: "",
			})

			return 1
        }
		
		return result
	} catch(error) {
        console.log(error)
    }
}

export async function deleteVideo(url, uid) {
    try {
		// Create a reference to the file to delete
		var desertRef = await db.storage().ref().child("videos/"+url);

		// Delete the file
		let result = await desertRef.delete().then(async () => {
			//очистить данные о видео
			await db.firestore().collection('offers').doc(uid).update({
				responses: [],
				video: "",
				video_mobile: "",
				videoApproved: false,
				status: false,
				video_name: "",
				videoDate: "",
			})

			updateVideoStatus(0)

			return 1
		}).catch(function(e) {
			console.log(e.code)
			return e
		});

        if(result.code=="storage/object-not-found") {
            //очистить данные о видео
			await db.firestore().collection('offers').doc(uid).update({
				responses: [],
				video: "",
				videoApproved: false,
				status: false,
				video_name: "",
				videoDate: "",
			})

			updateVideoStatus(0)

			return 1
        }
		
		return result
	} catch(error) {
        console.log(error)
    }
}

const updateVideoStatus = async (has) => {
	try {
		var user = db.auth().currentUser;
		let uid = user.uid
		
		await fetch("https://api.asystent.biz/api/candidates/update/"+uid+"/"+has)
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response.json();
			})
			.then(data => {
				return data
			})
	} catch (e) {
		console.error(e)
	}
}
const updateVideoStatusAdmin = async (has,uid) => {
	try {
		return await fetch("https://api.asystent.biz/api/candidates/update/"+uid+"/"+has)
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response.json();
			})
			.then(data => {
				return data
			})
	} catch (e) {
		console.error(e)
	}
}

export async function getOffer(id) {
    try {
      let initialQuery = await db.firestore().collection('offers').doc(id).get();
      let documentData =  initialQuery.data();
  
      return documentData
    } catch (error) {
      console.log(error)
    }
}

//load video to firebase
export async function saveVideo(url,id) {
	try {
		db.firestore().collection('offers').doc(id).update({video_uploading: true})

		const metadata = {
			contentType: 'video/mp4'
		};
		const videoBlob = await new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest()
			xhr.onload = () => resolve(xhr.response)
			xhr.responseType = 'blob'
			xhr.open('GET', url, true)
			xhr.send(null)
		});

		const nameVideo = uuid()
		const uploadTask = await db.storage().ref().child('videos/'+nameVideo).put(videoBlob, metadata)
		const downloadURL = await uploadTask.ref.getDownloadURL()

		return {
			uri: downloadURL,
			name: nameVideo,
		}
	} catch(e) {
		console.error(e)
	}
}

//load video to firebase
export async function convertVideo(data) {
	try {
		const response = await axios.post('https://api.convertido.net/api/convert/asystent.biz',data);

		return response
	} catch(e) {
		console.error(e)
	}
}

export async function updateOffer(uid, responses, uriVideo) {
	try {
		db.firestore().collection('offers').doc(uid).update({
			responses: responses,
			video_uploading: false,
			video: uriVideo.uri,
			video_name: uriVideo.name,
			status: false,
			videoApproved: true,
			videoDate: new Date().getTime(),
		})

		updateVideoStatus(1)
	} catch(e) {
		alert(e)
	}
}